export default "__VITE_ASSET__e15e2b44__"